var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (block, sd, user, visibilityClass) {
if ( block.kind)
{
visibilityClass = block.kind.__typename === 'Channel' ? "Block__inner--channel--" + block.kind.visibility : ''
buf.push("<a" + (jade.attr("href", block.href, true, true)) + (jade.attr("data-client", block.klass, true, true)) + (jade.attr("data-id", block.id, true, true)) + " class=\"Block\"><div" + (jade.cls(['Block__inner',"Block__inner--" + (block.kind.__typename.toLowerCase()) + " " + (visibilityClass) + ""], [null,true])) + "><div class=\"Block__inner__connect js-connect-container\"></div><div class=\"Block__inner__overlay\">");
if ( block.kind.__typename !== 'Channel')
{
if ( block.kind.source_url || block.kind.file_url)
{
buf.push("<button class=\"Button Button--overlay js-source\">Source</button>");
}
if ( user && user.has('username'))
{
buf.push("<button class=\"Button Button--overlay js-connect\">Connect →</button>");
}
}
else if ( user && user.has('username'))
{
buf.push("<div class=\"Block__inner__overlay__channel-actions\"><button" + (jade.cls(['Button','Button--divider','js-follow',"Button--" + (block.kind.visibility) + ""], [null,null,null,true])) + ">Follow</button><button" + (jade.cls(['Button','Button--divider','js-connect',"Button--" + (block.kind.visibility) + ""], [null,null,null,true])) + ">Connect →</button></div>");
}
buf.push("</div>");
if ( block.kind.__typename === 'Channel')
{
buf.push("<h2>" + (null == (jade_interp = block.title) ? "" : jade_interp) + "</h2><div class=\"Block__inner--channel__stats\"><ul class=\"Block__inner--channel__stats__list\"><li>by " + (jade.escape((jade_interp = block.user.name) == null ? '' : jade_interp)) + "</li><li>" + (jade.escape((jade_interp = block.kind.counts.blocks) == null ? '' : jade_interp)) + " blocks &bull; " + (jade.escape((jade_interp = block.updated_at) == null ? '' : jade_interp)) + "</li></ul></div>");
}
if ( block.kind.__typename === 'Text')
{
buf.push("<div class=\"Block__inner--text__content\"><p>" + (null == (jade_interp = block.kind.content) ? "" : jade_interp) + "</p></div>");
}
if ( block.kind.file_extension && block.kind.file_extension !== 'pdf')
{
buf.push("<img" + (jade.attr("data-src", "" + (sd.IMAGE_PATH) + "iconic/file.svg", true, true)) + (jade.attr("data-file-extension", block.kind.file_extension, true, true)) + " class=\"iconic iconic-lg\">");
}
else if ( block.kind.image_url)
{
buf.push("<img" + (jade.attr("src", block.kind.image_url, true, true)) + ">");
}
buf.push("</div>");
if ( block.kind.__typename !== 'Channel')
{
buf.push("<div class=\"Block__caption\"><div class=\"Block__caption__title\">" + (jade.escape(null == (jade_interp = block.title) ? "" : jade_interp)));
if(block.kind.__typename === 'Attachment' && ['mp3', 'pdf'].indexOf(block.kind.file_extension))
{
buf.push("<img" + (jade.attr("data-src", "" + (sd.IMAGE_PATH) + "iconic/type-" + (block.kind.file_extension) + ".svg", true, true)) + " class=\"iconic iconic-sm\">");
}
if(block.kind.__typename === 'Embed')
{
buf.push("<img" + (jade.attr("data-src", "" + (sd.IMAGE_PATH) + "iconic/type-embed.svg", true, true)) + " class=\"iconic iconic-sm\">");
}
buf.push("</div><div class=\"Block__caption__meta\"><div class=\"Block__caption__meta__author\">Added by " + (jade.escape((jade_interp = block.user.name) == null ? '' : jade_interp)) + "</div><div class=\"Block__caption__meta__timestamp\">Updated " + (jade.escape((jade_interp = block.updated_at) == null ? '' : jade_interp)) + "</div></div></div>");
}
buf.push("</a>");
}
else
{
visibilityClass = block.__typename === 'Channel' ? "Block__inner--channel--" + block.visibility : ''
buf.push("<a" + (jade.attr("href", block.href, true, true)) + (jade.attr("data-client", block.klass, true, true)) + (jade.attr("data-id", block.id, true, true)) + " class=\"Block\"><div" + (jade.cls(['Block__inner',"Block__inner--" + (block.__typename.toLowerCase()) + " " + (visibilityClass) + ""], [null,true])) + "><div class=\"Block__inner__connect js-connect-container\"></div><div class=\"Block__inner__overlay\">");
if ( block.__typename !== 'Channel')
{
if ( block.source_url || block.file_url)
{
buf.push("<button class=\"Button Button--overlay js-source\">Source</button>");
}
if ( user && user.has('username'))
{
buf.push("<button class=\"Button Button--overlay js-connect\">Connect →</button>");
}
}
else if ( user && user.has('username'))
{
buf.push("<div class=\"Block__inner__overlay__channel-actions\"><button" + (jade.cls(['Button','Button--divider','js-follow',"Button--" + (block.visibility) + ""], [null,null,null,true])) + ">Follow</button><button" + (jade.cls(['Button','Button--divider','js-connect',"Button--" + (block.visibility) + ""], [null,null,null,true])) + ">Connect →</button></div>");
}
buf.push("</div>");
if ( block.__typename === 'Channel')
{
buf.push("<h2>" + (null == (jade_interp = block.title) ? "" : jade_interp) + "</h2><div class=\"Block__inner--channel__stats\"><ul class=\"Block__inner--channel__stats__list\"><li>by " + (jade.escape((jade_interp = block.user.name) == null ? '' : jade_interp)) + "</li><li>" + (jade.escape((jade_interp = block.counts.blocks) == null ? '' : jade_interp)) + " blocks &bull; " + (jade.escape((jade_interp = block.updated_at) == null ? '' : jade_interp)) + "</li></ul></div>");
}
if ( block.__typename === 'Text')
{
buf.push("<div class=\"Block__inner--text__content\"><p>" + (null == (jade_interp = block.content) ? "" : jade_interp) + "</p></div>");
}
if ( block.file_extension && block.file_extension !== 'pdf')
{
buf.push("<img" + (jade.attr("data-src", "" + (sd.IMAGE_PATH) + "iconic/file.svg", true, true)) + (jade.attr("data-file-extension", block.file_extension, true, true)) + " class=\"iconic iconic-lg\">");
}
else if ( block.image_url)
{
buf.push("<img" + (jade.attr("src", block.image_url, true, true)) + ">");
}
buf.push("</div>");
if ( block.__typename !== 'Channel')
{
buf.push("<div class=\"Block__caption\"><div class=\"Block__caption__title\">" + (jade.escape(null == (jade_interp = block.title) ? "" : jade_interp)));
if(block.__typename === 'Attachment' && ['mp3', 'pdf'].indexOf(block.file_extension))
{
buf.push("<img" + (jade.attr("data-src", "" + (sd.IMAGE_PATH) + "iconic/type-" + (block.file_extension) + ".svg", true, true)) + " class=\"iconic iconic-sm\">");
}
if(block.__typename === 'Embed')
{
buf.push("<img" + (jade.attr("data-src", "" + (sd.IMAGE_PATH) + "iconic/type-embed.svg", true, true)) + " class=\"iconic iconic-sm\">");
}
buf.push("</div><div class=\"Block__caption__meta\"><div class=\"Block__caption__meta__author\">Added by " + (jade.escape((jade_interp = block.user.name) == null ? '' : jade_interp)) + "</div><div class=\"Block__caption__meta__timestamp\">Updated " + (jade.escape((jade_interp = block.updated_at) == null ? '' : jade_interp)) + "</div></div></div>");
}
buf.push("</a>");
}}.call(this,"block" in locals_for_with?locals_for_with.block:typeof block!=="undefined"?block:undefined,"sd" in locals_for_with?locals_for_with.sd:typeof sd!=="undefined"?sd:undefined,"user" in locals_for_with?locals_for_with.user:typeof user!=="undefined"?user:undefined,"visibilityClass" in locals_for_with?locals_for_with.visibilityClass:typeof visibilityClass!=="undefined"?visibilityClass:undefined));;return buf.join("");
};
module.exports = template;